import { Component, Input, Output,EventEmitter, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { QuestionBase } from './question-base';
import { GlobalConstants, ImageTypes } from 'src/app/services/global-constants';
import { iconOptions } from './iconoptions';

@Component({
  selector: 'app-question',
  templateUrl: './dynamic-form-question.component.html',
  styleUrl:'./dynamic-form-question.component.scss'
})
export class DynamicFormQuestionComponent {
  @Input() question!: QuestionBase<string>;
  @Input() form!: FormGroup;
  @Output() isImage:EventEmitter<boolean> = new EventEmitter<boolean>;
  @Output() checkBoxChange:EventEmitter<boolean> = new EventEmitter<boolean>;
  @Output() fileData:EventEmitter<boolean> = new EventEmitter<boolean>;
  @Output() imgData:EventEmitter<any> = new EventEmitter<any>;
  @Output() deleteLink:EventEmitter<any> = new EventEmitter<any>;
  @Input() enabled:boolean = true;
  fileLinks:any = [];
  minDate = new Date();

  staticURL = GlobalConstants.staticFilesURL;
  iconOptions = iconOptions

  useTextArea: boolean = false;

  get isValid() { return this.form.controls[this.question.key].valid; }

  checkisImg(arg0: string|undefined): any {
    if(arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false
    }
  }

  isVisible(value: string): boolean {
    try {
      const func = new Function(`return (${value})`);
      return func();
    } catch (error) {
      console.error("Invalid expression:", value);
      return false;
    }
  }  

  filterLinks(link:any) {
    this.question.fileLinks = this.question.fileLinks.filter((q:any) => {
      return q.name != link.name && q.link != link.link;
    })
  }

  deleteLinkRequest(link:any) {
    this.deleteLink.emit(link);
    this.filterLinks(link);
  }

  ngOnInit() {
    if (this.question.controlType == 'file') {
      this.fileLinks = this.question.fileLinks.map((e:any) => e.name);
    }
    if(this.question.disable == true){
      this.form.controls[this.question.key].disable()
    }
    this.minDate.setHours(0, 0, 0, 0);
  }

  onChange(event:any) {
    console.log(event);
    const file: File = event.target.files[0];
    let obj:any = {};
    console.log(this.question.filetype);
    obj[this.question.key] = {
      file:file,
      type:this.question.filetype || "ORGANIZATIONAL_UNIT"
    };
    console.log('FILE IMAG',obj);
    this.imgData.emit(obj);
  }

  onFileChange(event:any) {
    const file: File = event.target.files[0];
    let obj:any = {};
    console.log(this.question.filetype);
    obj['file'] = {
      file:file,
      type:this.question.filetype || "ORGANIZATIONAL_UNIT"
    };
    console.log('FILE',obj);
    this.fileLinks.push(file.name);
    this.fileData.emit(obj);
  }

  onImgTypeChange(checked:boolean) {
    this.isImage.emit(checked)
  }

  filteredIconOptions: any = iconOptions;

  
  customFilterFunction(event: any): void {
    const searchText = event.target.value.toLowerCase();
    if (!searchText) {
      // If search text is empty, reset options
      this.iconOptions = iconOptions;
      return;
    }
  
    // Filter options based on search text
    this.iconOptions = iconOptions.filter(option =>
      option.label.toLowerCase().includes(searchText)
    );
  }

  checkBoxChanged(event:any){
    this.checkBoxChange.emit(event)
  }
  
}


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/